// extracted by mini-css-extract-plugin
module.exports = {"comp":"ModuleB_comp__SaK_q"};